import React from "react";
import { Button } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { useNavigate } from "react-router-dom";
import NotificationBox from "../common/NotificationBox";

const Header = ({ setIsLogout }) => {
  const navigatory = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    setIsLogout(false);
    window.location.href = "/";
  };

  const toggleSidebar = () => {
    const sidebar = document.querySelector("#sidebar");
    if (!sidebar) return;
    sidebar.classList.toggle("hide");
    sidebar.classList.toggle("show");

    const isOpen = sidebar.classList.contains("show");
    if (isOpen) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }
  };

  return (
    <Navbar
      className="header px-3 py-2 bg-white border-bottom shadow-none"
      expand="lg"
    >
      <div className="d-flex align-items-center flex-grow-1">
        {/* Sidebar toggle */}
        <button
          type="button"
          id="sidebarCollapse"
          className="btn btn-outline-primary me-3 d-flex align-items-center justify-content-center"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
          aria-controls="sidebar"
        >
          <i className="fas fa-bars"></i>
        </button>

        {/* Brand */}
        <Navbar.Brand
          onClick={() => navigatory("/")}
          className="fw-bold text-primary cursor-pointer"
          style={{ fontSize: "1.25rem" }}
        >
          Jajot Enterprises
        </Navbar.Brand>
      </div>

      <div className="d-flex align-items-center">
        <NotificationBox />
        {localStorage.getItem("token") && (
          <Button
            variant="outline-danger"
            className="d-flex align-items-center"
            onClick={logout}
            title="Logout"
            aria-label="Logout"
          >
            <i className="fa-solid fa-right-from-bracket me-1"></i>
            <span className="d-none d-md-inline">Logout</span>
          </Button>
        )}
      </div>
    </Navbar>
  );
};

export default Header;
